const organizationDetailLayoutMeta = {
  layoutViewScope: 'organization-detail',
  layoutViewScopeParam: 'id',
} as const

export { organizationDetailLayoutMeta }
